import { tree } from '../../bot/dist/bot.esm.js'
import { postJSON } from '../../src/lib/fetch.js'
import { chat } from './chat.js'
import { envReplace, refParam, uniq } from './util.js'

const user = {
  cartItems: null,
  likes: [],
  ranking: null,
  clicks: []
}

function onmessage(evt) {
  if (!evt.data) return
  if (evt.data === 'restart') {
    restart()
  }
  if (evt.data.cart) {
    user.cartItems = evt.data.cart
  }
  const { message } = evt.data
  if (message) {
    if (message.text) message.text = this.__(message.text)
    chat.send(evt.data.message)
  }
  const productId =
    evt.data.productId || (evt.data.product && evt.data.product.product)
  if (evt.data.type === 'moreLikeThis' && productId) {
    moreLikeThis(productId)
  }
  if (evt.data.type === 'startSession') {
    this.$root.track({
      event_type: 'user_interaction',
      interaction_type: 'start-session',
      page_type: 'dreambuddy'
    })
  }
}

function moreLikeThis(product, all) {
  user.clicks.push({
    id: product.product,
    timestamp: new Date().getTime()
  })

  chat.history.push({
    data: {
      clicks: user.clicks,
      exclude: all
        .filter(p => !user.clicks.map(c => c.id).includes(p.product))
        .map(item => {
          return {
            id: item.product,
            reconsumable: false
          }
        })
    }
  })

  chat.send({
    text: chat.__('more like this'),
    data: {
      moreIds: (chat.history.state().moreIds || '')
        .split(',')
        .concat(product.product)
        .filter(Boolean)
        .filter(uniq)
        .join(',')
    },
    next: 'suggestions'
  })
}

function toggleLike(product) {
  if (hasLiked(product)) {
    user.likes = user.likes.filter(p => p.product !== product.product)
  } else {
    user.likes = user.likes.concat(product)
  }
  chat.history.push({ data: { likes: user.likes } })
}

export function resetLikes() {
  console.log('resetLikes')
  user.likes = []
  chat.history.push({ data: { likes: user.likes } })
}

function restart() {
  user.ranking = null
  user.likes = []
  chat.history.items = chat.history.items.slice(0, 2)
}

function hasLiked(product) {
  return user.likes.find(p => p.product === product.product)
}

async function getRanking() {
  const nextNode = {}
  user.ranking = null
  await tree.ranking.enter({
    nextNode,
    state: this.state
  })
  if (nextNode.data) {
    user.ranking = nextNode.data.ranking
  }
}

export default {
  data() {
    return {
      history: chat.history,
      productDetail: null,
      testStyle: 0,
      user
    }
  },
  computed: {
    cart() {
      return !!user.cartItems
    },
    bubble() {
      return window.location.search.includes('bubble=1')
    },
    full() {
      return window.location.search.includes('full=1')
    },
    kiosk() {
      return window.location.search.includes('kiosk=1')
    },
    historyItems() {
      return this.history.items
    },
    messages() {
      return this.historyItems.filter(m => m.text)
    },
    state() {
      return this.historyItems.reduce(
        (state, obj) => Object.assign({}, state, obj.data),
        {}
      )
    },
    __() {
      // chat.__ is only valid at the time it is called
      // if it would be added in methods, it will not sync when the user changes the language
      // That's why it's in computed
      return chat.__
    }
  },
  methods: {
    getRanking,
    hasLiked,
    moreLikeThis,
    onmessage,
    resetLikes,
    restart,
    showProduct(product, all = []) {
      this.$root.productDetail = product
      user.clicks.push({
        id: product.product,
        timestamp: new Date().getTime()
      })
      chat.history.push({
        data: {
          clicks: user.clicks,
          exclude: all
            .filter(p => !user.clicks.map(c => c.id).includes(p.product))
            .map(item => {
              return {
                id: item.product,
                reconsumable: false
              }
            })
        }
      })
      this.$root.track({
        event_type: 'click_on_recommendation',
        action_item: product.product,
        page_type: 'dreambuddy',
        list_name: product.list_name,
        channel:
          window.name === 'messenger_ref'
            ? 'messenger'
            : window.innerWidth < 500
            ? 'mobile-website'
            : 'website',
        request_id: `${product.request_id}`
      })
    },
    openProductLink(product, all = []) {
      user.clicks.push({
        id: product.product,
        timestamp: new Date().getTime()
      })
      chat.history.push({
        data: {
          clicks: user.clicks,
          exclude: all
            .filter(p => !user.clicks.map(c => c.id).includes(p.product))
            .map(item => {
              return {
                id: item.product,
                reconsumable: false
              }
            })
        }
      })
      this.$root.track({
        event_type: 'click_on_recommendation',
        action_item: product.product,
        page_type: 'dreambuddy',
        list_name: product.list_name,
        channel:
          window.name === 'messenger_ref'
            ? 'messenger'
            : window.innerWidth < 500
            ? 'mobile-website'
            : 'website',
        request_id: `${product.request_id}`
      })
      const lang = this.$root.state.lang || 'nl'
      window.open(refParam(envReplace(product[`link_${lang}`])), '_blank')
    },
    toggleLike,
    track(evt) {
      if (!evt.device_id && !this.$root.state.session_id) {
        this.$root.createSession()
      }
      if (!evt.device_id) {
        evt.device_id = this.$root.state.session_id
      }
      if (!evt.channel) {
        evt.channel = window.innerWidth < 500 ? 'mobile-website' : 'website'
      }

      console.log('tracking', evt)

      if (window.location.host.includes('localhost')) {
        return Promise.resolve()
      }

      return postJSON('https://colruyt.froomle.com/api/dreamland/events', {
        events: [evt]
      }).catch(e => {
        if (e.type === 'cors') {
          console.warn('cors', e)
        } else {
          console.error('track.error', e)
        }
      })
    },
    createSession() {
      this.$root.state.session_id = Array.apply(null, Array(20))
        .map(
          () =>
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'[
              Math.floor(Math.random() * 62)
            ]
        )
        .join('')
    }
  },
  mounted() {
    window.addEventListener('message', this.onmessage, false)

    // Cart feature detection
    window.top.postMessage({ type: 'syncCart' }, '*')
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onmessage, false)
  }
}
